import { computed } from "vue";
import { useStore } from "vuex";
import yup from "@component_path/inquiry_form_common_module/customValidation";

export const useAuctionCompaniesField = (required, messages = {}) => {
  const fieldName = computed(() => "agent_selection_auction_ids");
  const validator = yup
    .array()
    .of(
      yup
        .string()
        .requirement(
          required,
          messages["requirement"] || "転職支援会社は必須項目です"
        )
    )
    .min(1, messages["requirement"] || "転職支援会社は必須項目です");

  return { validator, fieldName };
};

export const useAuctionCompaniesStore = () => {
  const store = useStore();

  const agentSelectionAuctionIds = computed(
    () => store.state.formData.agent_selection_auction_ids
  );
  const agentSelectionAuctions = computed(
    () => store.state.masterData.agentSelectionAuctions
  );
  const dispatcher = computed(() => "formData/setAgentSelectionAuctionIds");

  return { agentSelectionAuctionIds, agentSelectionAuctions, dispatcher };
};
